<template>
  <div>
    <a-modal v-model="visible" width="660px" title="推送消息" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="close('cancel')">
      <a-form-model ref="modalForm" :model="modalForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="推送群聊" prop="chat_ids">
          <a-select v-model="modalForm.chat_ids" mode="multiple" placeholder="请选择推送消息的群聊" @focus="getFeiShuChatList">
            <a-select-option v-for="(chat, index) in chatList" :key="index" :value="chat.chat_id"> {{ chat.name }} ({{ chat.chat_id }})</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="更新内容" prop="changelog">
          <a-textarea v-model="modalForm.changelog" :placeholder="changelog" :rows="6" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { applicationVersionPush } from '@/api/tools/application';
import { feiShuChatList } from '@/api/system/service';
export default {
  props: {
    versionId: {
      type: [Number, String],
      default: null
    },
    changelog: {
      type: [String, Array],
      default: []
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      chatList: [],
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      modalForm: {
        chat_ids: [],
        changelog: null
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.modalForm = {
          chat_ids: [],
          changelog: null
        };
      }
    }
  },
  methods: {
    close() {
      this.loading = false;
      this.visible = false;
      this.$emit('close');
    },

    getFeiShuChatList() {
      feiShuChatList({}).then(response => {
        this.chatList = response.data.items;
      });
    },

    submit() {
      this.loading = true;
      applicationVersionPush({ version_id: this.versionId, ...this.modalForm })
        .then(() => {
          this.$message.success('发送成功');
          this.close();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
